import L from "leaflet"; // Import leaflet directly for the custom icon

// import tcIcon from "./Icons/track_circuit_icon.png";
// import pmIcon from "./Icons/pm_icon.png";
// import sgIcon from "./Icons/signal_icon.png";
// import acIcon from "./Icons/ac_icon.png";
// import batIcon from "./Icons/battery_icon.png";
// import bbIcon from "./Icons/busbar_icon.png";
// import ipsIcon from "./Icons/ips_icon.png";
// import lcgIcon from "./Icons/lc_gate_icon.png";
import defaultIcon from "./Icons/default.png";
import accessPoint from "./Icons/Access Point.svg";
import AGDB from "./Icons/AGDB.svg";
import Amplifier from "./Icons/Amplifier.svg";
import Battery from "./Icons/Battery.svg";
import BTSCARDRACK from "./Icons/BTS Card Rack.svg";
import Camera from "./Icons/Camera.svg";
import CGDB from "./Icons/CGDB.svg";
import Charger from "./Icons/charger.svg";
import CPU from "./Icons/CPU.svg";
import DTMFPhone from "./Icons/DTMF phone.svg";
import Earthing from "./Icons/Earthing.svg";
import ExchangeDevice from "./Icons/Exchange Device.svg";
import FDMS from "./Icons/FDMS.svg";
import Gateway from "./Icons/Gateway.svg";
import GPSClock from "./Icons/GPS Clock.svg";
import MIC from "./Icons/MIC.svg";
import MLDB from "./Icons/MLDB.svg";
import Modem from "./Icons/Modem.svg";
import Monitor from "./Icons/Monitor.svg";
import NVR from "./Icons/NVR.svg"
import OFCCable from "./Icons/OFC Cable.svg"
import OLTE from "./Icons/OLTE.svg"
import PairCable from "./Icons/Pair Cable.svg"
import PC from "./Icons/PC.svg"
import PDC from "./Icons/PDC.svg"
import PFDB from "./Icons/PFDB.svg"
import Router from "./Icons/Router.svg"
import Server from "./Icons/Server.svg"
import SLDB from "./Icons/SLDB.svg"
import Smoke_Temp from "./Icons/Smoke & Temp.svg"
import SMPSCharger from "./Icons/SMPS Charger.svg"
import Speaker from "./Icons/Speaker.svg"
import STM from "./Icons/STM.svg"
import Switch from "./Icons/SWITCH.svg"
import TV from "./Icons/TV.svg"
import UPS from "./Icons/UPS.svg"
import VHF_SET from "./Icons/VHF SET.svg"
import VOIP_PHONE from "./Icons/VOIP phone.svg"
import Walkie_Talkie from "./Icons/Walkie Talkie.svg"


const typeIconMap = {
  // TC: tcIcon,
  // TRACK: tcIcon,
  // PM: pmIcon,
  // SG: sgIcon,
  // AC: acIcon,
  // AXL: acIcon,
  // BAT: batIcon,
  // BHMS: batIcon,
  // BB: bbIcon,
  // IPS: ipsIcon,
  // LCG: lcgIcon,


  default: defaultIcon,
  ERS: Smoke_Temp,
  'Modem': Modem,
  // 'Auto Changeover Converter': ,
  NVR,
  // 'SDH/PDH(M)',
  // 'Magneto Phone',
  UPS,
  // MUX,
  // ER,
  'GPS Clock': GPSClock,
  'CPU': CPU,
  'DTMF(M)': DTMFPhone,
  // 'DC-AC Converter',
  // 'IPIS(M)',
  // 'OVD',
  'STM': STM,
  'OLTE': OLTE,
  'AGDB': AGDB,
  'SPEAKER': Speaker,
  'VHF Set(M)': VHF_SET,
  // 'Auto Exchange(M)',
  'Walkie Talkie': Walkie_Talkie,
  // 'D-SLAM': ,
  Amplifier,
  'Router': Router,
  // 'TVD': ,
  PDC,
  Battery,
  // FXS,
  // '5 Core Quad',
  // ERS,
  '50 Pair Cable': PairCable,
  // IVD,
  // 'PIJF Cable',
  'BTS Card Rack': BTSCARDRACK,
  'OFC Cable': OFCCable,
  // 'KYM Switch',
  'Exchange Device': ExchangeDevice,
  // 'VHF SET',
  // 'SPT Phone',
  // 'Controller Console',
  // '4 Core Quad',
  'CAMERA': Camera,
  // 'Phone': ,
  'DTMF Phone': DTMFPhone,
  MIC,
  // FXO,
  PC: PC,
  Server: Server,
  MLDB: MLDB,
  // 'MTRC(M)',
  Switch: Switch,
  FDMS: FDMS,
  Earthing: Earthing,
  // 'Quad',
  PFDB: PFDB,
  CGDB: CGDB,
  // 'Change Over',
  'SMPS': SMPSCharger,
  'VoIP Phone': VOIP_PHONE,
  SLDB: SLDB,
  Charger: Charger,
  TV: TV,
  // 'Optical Switch',
  'AP': accessPoint,
  Gateway: Gateway,
  Monitor: Monitor,
  // 'VoIP(M)',
  // '6 Core Quad'
};


// const customIcon = L.divIcon({
//     className: 'custom-marker-icon',
//     html: `<div style="background-color: red;" class="marker-circle">${dt}</div>`,
// });

export const getMarkerIcon = (type, selectedAsset, deviceid) => {
  let selectedIconClass = "";
  if (selectedAsset) {
    selectedIconClass = selectedAsset.id === deviceid ? "selcetdIcon" : "";
  } else {
    selectedIconClass = "";
  }
  const icon = L.divIcon({
    className: "custom-marker-icon",
    iconAnchor: [16, 20],
    html: `<div class="icon-background  ${selectedIconClass}">
                  <img  src="${typeIconMap?.[type] ?? defaultIcon
      }" alt="Custom Icon" class="icon-image" width="12" height="12">
                </div>`,
  });
  return icon;
};
